var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCastbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "castbox__c",
    x1: -9.267,
    x2: 16,
    y1: 16,
    y2: 41.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5321"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "castbox__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#castbox__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "castbox__b",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0c12.357 0 16 3.643 16 16s-3.643 16-16 16S0 28.357 0 16 3.643 0 16 0Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#castbox__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#castbox__c)",
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M18.663 11.86v6.861a1 1 0 1 1-2 0v-1.935a.68.68 0 0 0-1.327.028h-.003v1.787a1 1 0 1 1-2 0v-2.427a.68.68 0 0 0-1.333 0v4.816a1 1 0 1 1-2 0v-3.536a.613.613 0 0 0-.667-.543.613.613 0 0 0-.666.543v.26a1 1 0 1 1-2 0v-3.09a1 1 0 1 1 2 0v.259a.613.613 0 0 0 .666.543c.334.031.63-.21.667-.543v-2.227a1 1 0 0 1 2 0v.942a.68.68 0 0 0 1.333 0v-2.596a1 1 0 1 1 2 0v3.241h.003a.68.68 0 0 0 1.327.028V11.86a1 1 0 1 1 2 0ZM21 13.537a.992.992 0 0 0-1 .983v3.923a1 1 0 1 0 2 0V14.52a.992.992 0 0 0-1-.983Zm2.333 2.975a.992.992 0 0 1 1-.984.992.992 0 0 1 1 .984v.978a1 1 0 1 1-2 0v-.978Z",
    clipRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCastbox);
export default __webpack_public_path__ + "static/media/castbox.a016ab8e7b108c7076ebd9315beb213b.svg";
export { ForwardRef as ReactComponent };